import React, { useState, memo } from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";
import { useQueryClient, useIsFetching, useIsMutating } from "react-query";

import { BOOTSTRAP_VARIANTS } from "../../constants/common";
import { Button, GridView, Loading } from "../../components/commons";
import { showErrorNotification } from "../../utils/toastr";

import { IconEdit } from "../../assests/icons";

import { useGetProjects, useCreateProjects, useUpdateProject } from "../../api";

import EditProject from "./EditProject";

const Projects = ({ clientAccountId }) => {
  const { t } = useTranslation();

  const isFetching = useIsFetching();
  const isMutating = useIsMutating();

  const queryClient = useQueryClient();
  const [selectedProject, setProject] = useState(null);
  const [query, setQuery] = useState({ page: 1, pageSize: 7 });

  const { data: projects, refetch: refetchProjects } = useGetProjects(
    clientAccountId,
    query.page,
    query.pageSize
  );
  const { mutateAsync: updateProject } = useUpdateProject();
  const { mutateAsync: createProjects } = useCreateProjects();

  const handleCreateProject = (projectData) => {
    const data = { ...projectData };
    data.client_account_id = clientAccountId;
    if (data.id) {
      updateProject(data).then(() => {
        setProject(null);
        refetchProjects();
        queryClient.invalidateQueries("dimension-values");
      });
    } else {
      createProjects(data).then(() => {
        setProject(null);
        refetchProjects();
        queryClient.invalidateQueries("dimension-values");
      });
    }
  };

  const handleQueryChange = (data) => {
    const q = {
      ...(query || {}),
      ...data,
    };
    setQuery(q);
  };

  return (
    <div className="detail-page">
      <Loading childLoading loading={isFetching > 0 || isMutating > 0} />
      {selectedProject === null ? (
        <div className="business-partner-list">
          <div className="business-partner-gridview">
            <GridView
              columns={[
                {
                  Header: t("master_data.gridview.id"),
                  accessor: "sequence_number",
                  align: "left",
                  maxWidth: "9%",
                },
                {
                  Header: t("master_data.gridview.name"),
                  accessor: "name",
                  align: "left",
                  maxWidth: "15%",
                },
                {
                  Header: "",
                  accessor: "delete",
                  align: "left",
                  maxWidth: "6%",
                  className: "delete-wrap",
                  Cell: (cellProps) => (
                    <span
                      className="delete-icon"
                      role="button"
                      onClick={() => setProject(cellProps.row.original)}
                    >
                      <IconEdit />
                    </span>
                  ),
                },
              ]}
              data={(projects || {}).projects}
              pages={(projects || {}).pages}
              relativeRowHeight={30}
              onStateChange={(q) => handleQueryChange(q)}
              emptyStateTitle=""
            />
          </div>
          <div className="text-right">
            <Button
              size="md40"
              className="add-button"
              variant={BOOTSTRAP_VARIANTS.SECONDARY}
              text={t("master_data.add_new_project")}
              onClick={() => setProject(undefined)}
            />
          </div>
        </div>
      ) : (
        <EditProject
          onBack={() => setProject(null)}
          onSave={handleCreateProject}
          showErrorNotification={showErrorNotification}
          project={selectedProject}
        />
      )}
    </div>
  );
};

export default memo(Projects);
